module.exports = __webpack_public_path__ + "fonts/STXINGKA.7f335aa.TTF";